enum CompanyFormType {
  name,
  contactName,
  contactEmail,
  contactPhoneNumber,
  contactAddress,
  contactCity,
}

export default CompanyFormType;
